/* Webgro x G&H  |  v1.0.0  |  Theme JS */

(function () {
  'use strict';

  /* Nav: transparent on hero pages, solid everywhere else */
  var nav = document.getElementById('siteNav');
  if (nav) {
    var hasHero = !!document.querySelector('.hero, [data-transparent-header]');
    if (!hasHero) nav.classList.add('nav--solid');
    var onScroll = function () {
      if (window.scrollY > 60) nav.classList.add('nav--solid');
      else if (hasHero) nav.classList.remove('nav--solid');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mega menu: hover to open (with intent delay), click as fallback */
  var megaBackdrop = document.getElementById('megaBackdrop');
  var navItems = nav ? nav.querySelectorAll('.nav__item') : [];
  var megaOpen = false;
  var activeMegaItem = null;
  var hoverIntent = null;
  var closeIntent = null;
  var OPEN_DELAY = 180;
  var CLOSE_DELAY = 280;
  var isTouch = false;

  /* Detect touch to disable hover on touch devices */
  document.addEventListener('touchstart', function () { isTouch = true; }, { once: true, passive: true });

  function openMega(item) {
    var mega = item.querySelector('.mega');
    if (!mega) return;
    clearTimeout(closeIntent);
    if (activeMegaItem && activeMegaItem !== item) {
      var prev = activeMegaItem.querySelector('.mega');
      if (prev) prev.classList.remove('is-active');
      activeMegaItem.classList.remove('is-active');
    }
    mega.classList.add('is-active');
    item.classList.add('is-active');
    activeMegaItem = item;
    if (!megaOpen) {
      megaOpen = true;
      nav.classList.add('mega-open');
      megaBackdrop.classList.add('is-open');
    }
  }

  function closeMega() {
    if (!megaOpen) return;
    clearTimeout(hoverIntent);
    clearTimeout(closeIntent);
    megaOpen = false;
    nav.classList.remove('mega-open');
    megaBackdrop.classList.remove('is-open');
    if (activeMegaItem) {
      var mega = activeMegaItem.querySelector('.mega');
      if (mega) mega.classList.remove('is-active');
      activeMegaItem.classList.remove('is-active');
      activeMegaItem = null;
    }
    if (nav) onScroll();
  }

  function scheduleClose() {
    clearTimeout(closeIntent);
    closeIntent = setTimeout(closeMega, CLOSE_DELAY);
  }

  navItems.forEach(function (item) {
    var link = item.querySelector('.nav__link');
    if (!link) return;
    var hasMega = !!item.querySelector('.mega');

    /* Click: if mega is already open for this item, navigate to the link.
       Otherwise open the mega (prevent default only on first click). */
    link.addEventListener('click', function (e) {
      if (!hasMega) { closeMega(); return; }
      if (activeMegaItem === item && megaOpen) {
        /* Mega already open for this item — allow the link to navigate */
        closeMega();
        return;
      }
      e.preventDefault();
      openMega(item);
    });

    if (!hasMega) return;

    /* Hover intent: open after short delay, switch instantly if already open */
    item.addEventListener('mouseenter', function () {
      if (isTouch) return;
      clearTimeout(closeIntent);
      if (megaOpen) {
        /* Already open: switch immediately */
        if (activeMegaItem !== item) openMega(item);
      } else {
        /* Not open: wait for intent */
        clearTimeout(hoverIntent);
        hoverIntent = setTimeout(function () { openMega(item); }, OPEN_DELAY);
      }
    });

    item.addEventListener('mouseleave', function () {
      if (isTouch) return;
      clearTimeout(hoverIntent);
      scheduleClose();
    });
  });

  /* Keep mega open when cursor moves into the panel */
  nav.querySelectorAll('.mega').forEach(function (mega) {
    mega.addEventListener('mouseenter', function () {
      if (isTouch) return;
      clearTimeout(closeIntent);
    });
    mega.addEventListener('mouseleave', function () {
      if (isTouch) return;
      scheduleClose();
    });
  });

  nav.querySelectorAll('.mega__close').forEach(function (btn) {
    btn.addEventListener('click', closeMega);
  });
  if (megaBackdrop) megaBackdrop.addEventListener('click', closeMega);

  var navBrand = nav.querySelector('.nav__brand');
  var navActions = nav.querySelector('.nav__actions');
  if (navBrand) navBrand.addEventListener('mouseenter', function () { if (megaOpen) { clearTimeout(hoverIntent); scheduleClose(); } });
  if (navActions) navActions.addEventListener('mouseenter', function () { if (megaOpen) { clearTimeout(hoverIntent); scheduleClose(); } });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && megaOpen) closeMega();
  });

  /* Hero video: pause when off-screen */
  var heroVideo = document.querySelector('.hero__video');
  if (heroVideo) {
    var vio = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) heroVideo.play().catch(function () {});
      else heroVideo.pause();
    }, { threshold: 0.15 });
    vio.observe(heroVideo);
  }

  /* Reveal on scroll */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          rio.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { rio.observe(el); });
  }

  /* Shop The Look: spotlight interaction */
  var stl = document.getElementById('stl');
  if (stl) {
    var chips = stl.querySelectorAll('.stl__chip');
    chips.forEach(function (chip) {
      var x = chip.dataset.spotX;
      var y = chip.dataset.spotY;
      var enter = function () {
        if (x) stl.style.setProperty('--spot-x', x);
        if (y) stl.style.setProperty('--spot-y', y);
        stl.classList.add('is-active');
      };
      var leave = function () { stl.classList.remove('is-active'); };
      chip.addEventListener('mouseenter', enter);
      chip.addEventListener('mouseleave', leave);
      chip.addEventListener('focus', enter);
      chip.addEventListener('blur', leave);
    });
  }

  /* ---- Search overlay ---- */
  var searchToggle = document.getElementById('searchToggle');
  var searchOverlay = document.getElementById('siteSearch');
  var searchInput = document.getElementById('searchInput');
  var searchClose = document.getElementById('searchClose');
  var searchBackdrop = document.getElementById('searchBackdrop');
  var searchDefault = document.getElementById('searchDefault');
  var searchResults = document.getElementById('searchResults');
  var searchResultsGrid = document.getElementById('searchResultsGrid');
  var searchResultsHeading = document.getElementById('searchResultsHeading');
  var searchNoResults = document.getElementById('searchNoResults');
  var searchEmptyTitle = document.getElementById('searchEmptyTitle');
  var searchViewAll = document.getElementById('searchViewAll');
  var searchRecent = document.getElementById('searchRecent');
  var searchRecentList = document.getElementById('searchRecentList');
  var searchPopular = document.getElementById('searchPopular');
  var searchCollections = document.getElementById('searchCollections');
  var searchCollectionsList = document.getElementById('searchCollectionsList');
  var searchPages = document.getElementById('searchPages');
  var searchPagesList = document.getElementById('searchPagesList');
  var searchClearRecent = document.getElementById('searchClearRecent');

  if (searchToggle && searchOverlay) {
    var searchTimeout;
    var isSearchOpen = false;

    function openSearch() {
      isSearchOpen = true;
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchBackdrop.classList.add('is-open');
      searchToggle.setAttribute('aria-expanded', 'true');
      if (nav) {
        nav.classList.add('nav--solid');
        nav.classList.add('nav--search-open');
      }
      document.body.style.overflow = 'hidden';
      setTimeout(function () { searchInput.focus(); }, 80);
      renderRecentSearches();
    }

    function closeSearch() {
      isSearchOpen = false;
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchBackdrop.classList.remove('is-open');
      searchToggle.setAttribute('aria-expanded', 'false');
      if (nav) nav.classList.remove('nav--search-open');
      document.body.style.overflow = '';
      searchInput.value = '';
      exitSearchMode();
      showDefaultContent();
      if (nav) onScroll();
    }

    function showDefaultContent() {
      if (searchDefault) searchDefault.style.display = '';
      if (searchResults) searchResults.style.display = 'none';
      if (searchNoResults) searchNoResults.style.display = 'none';
      if (searchViewAll) searchViewAll.style.display = 'none';
    }

    function showResultsPanel() {
      if (searchDefault) searchDefault.style.display = 'none';
      if (searchResults) searchResults.style.display = '';
    }

    function enterSearchMode() {
      if (searchPopular) searchPopular.style.display = 'none';
      if (searchRecent) searchRecent.style.display = 'none';
    }

    function exitSearchMode() {
      if (searchPopular) searchPopular.style.display = '';
      renderRecentSearches();
      if (searchCollections) searchCollections.style.display = 'none';
      if (searchPages) searchPages.style.display = 'none';
    }

    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (isSearchOpen) closeSearch();
      else openSearch();
    });

    var searchToggleMob = document.getElementById('searchToggleMob');
    if (searchToggleMob) {
      searchToggleMob.addEventListener('click', function (e) {
        e.preventDefault();
        if (isSearchOpen) closeSearch();
        else openSearch();
      });
    }

    searchClose.addEventListener('click', closeSearch);
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isSearchOpen) closeSearch();
    });

    /* Predictive search */
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      var q = this.value.trim();
      if (q.length < 2) {
        exitSearchMode();
        showDefaultContent();
        return;
      }
      enterSearchMode();
      searchTimeout = setTimeout(function () { fetchResults(q); }, 200);
    });

    /* Form submit saves recent search */
    var searchForm = searchOverlay.querySelector('form');
    if (searchForm) {
      searchForm.addEventListener('submit', function () {
        var q = searchInput.value.trim();
        if (q) saveRecentSearch(q);
      });
    }

    function fetchResults(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=4&resources[options][unavailable_products]=hide')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var results = (data.resources && data.resources.results) || {};
          var products = results.products || [];
          var collections = results.collections || [];
          var pages = results.pages || [];
          renderProducts(products, q);
          renderCollections(collections);
          renderPages(pages);
        })
        .catch(function () {});
    }

    function formatMoney(price) {
      var fmt = window.__ghMoneyFormat || '{{amount}}';
      return fmt.replace(/\{\{amount\}\}/g, price)
        .replace(/\{\{amount_no_decimals\}\}/g, Math.round(parseFloat(price)).toString())
        .replace(/\{\{amount_with_comma_separator\}\}/g, price.replace('.', ','))
        .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, Math.round(parseFloat(price)).toString());
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function renderProducts(products, q) {
      showResultsPanel();
      if (products.length === 0) {
        searchResultsHeading.textContent = 'Results for “' + q + '”';
        searchResultsGrid.innerHTML = '';
        searchNoResults.style.display = '';
        if (searchEmptyTitle) searchEmptyTitle.textContent = 'No results found for “' + q + '”';
        if (searchViewAll) searchViewAll.style.display = 'none';
        return;
      }
      searchNoResults.style.display = 'none';
      searchResultsHeading.textContent = 'Results for “' + q + '”';
      var html = '';
      products.forEach(function (p, i) {
        var imgBase = p.image || '';
        var imgSep = imgBase.indexOf('?') > -1 ? '&' : '?';
        var imgSrc = imgBase ? imgBase + imgSep + 'width=800' : '';
        var imgSrcset = imgBase ? (imgBase + imgSep + 'width=400 400w, ' + imgBase + imgSep + 'width=600 600w, ' + imgBase + imgSep + 'width=800 800w') : '';
        var hasCompare = p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price);
        var priceHtml;
        if (hasCompare) {
          priceHtml = '<span><span class="search__product-price search__product-sale">' + formatMoney(p.price) + '</span>' +
            '<span class="search__product-compare">' + formatMoney(p.compare_at_price) + '</span></span>';
        } else {
          priceHtml = '<span class="search__product-price">' + formatMoney(p.price) + '</span>';
        }
        html += '<a href="' + escapeHtml(p.url) + '" class="search__product" style="animation-delay:' + (i * 0.07) + 's">' +
          '<div class="search__product-img">' +
          (imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" srcset="' + escapeHtml(imgSrcset) + '" sizes="(min-width: 1080px) 300px, 200px" alt="" loading="lazy" width="800">' : '') +
          '</div>' +
          '<div class="search__product-info">' +
          '<span class="search__product-title">' + escapeHtml(p.title) + '</span>' +
          priceHtml +
          '</div>' +
          (p.type ? '<span class="search__product-type">' + escapeHtml(p.type) + '</span>' : '') +
          '</a>';
      });
      searchResultsGrid.innerHTML = html;

      if (searchViewAll) {
        searchViewAll.href = '/search?q=' + encodeURIComponent(q);
        searchViewAll.style.display = '';
      }
    }

    function renderCollections(collections) {
      if (!searchCollections || !searchCollectionsList) return;
      if (!collections || collections.length === 0) {
        searchCollections.style.display = 'none';
        return;
      }
      searchCollections.style.display = '';
      var html = '';
      collections.forEach(function (c) {
        html += '<li><a href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a></li>';
      });
      searchCollectionsList.innerHTML = html;
    }

    function renderPages(pages) {
      if (!searchPages || !searchPagesList) return;
      if (!pages || pages.length === 0) {
        searchPages.style.display = 'none';
        return;
      }
      searchPages.style.display = '';
      var html = '';
      pages.forEach(function (p) {
        html += '<li><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></li>';
      });
      searchPagesList.innerHTML = html;
    }

    /* Popular / recent search term buttons */
    function bindTermButtons(container) {
      container.querySelectorAll('.search__term').forEach(function (btn) {
        btn.addEventListener('click', function () {
          searchInput.value = this.dataset.searchTerm;
          searchInput.dispatchEvent(new Event('input'));
          searchInput.focus();
        });
      });
    }

    bindTermButtons(document);

    /* Recent searches (localStorage) */
    function getRecentSearches() {
      try { return JSON.parse(localStorage.getItem('gh_recent') || '[]'); }
      catch (e) { return []; }
    }

    function saveRecentSearch(term) {
      var recent = getRecentSearches();
      recent = recent.filter(function (s) { return s.toLowerCase() !== term.toLowerCase(); });
      recent.unshift(term);
      if (recent.length > 5) recent = recent.slice(0, 5);
      try { localStorage.setItem('gh_recent', JSON.stringify(recent)); } catch (e) {}
      renderRecentSearches();
    }

    function renderRecentSearches() {
      if (!searchRecent || !searchRecentList) return;
      var recent = getRecentSearches();
      if (recent.length === 0) {
        searchRecent.style.display = 'none';
        return;
      }
      searchRecent.style.display = '';
      var html = '';
      recent.forEach(function (term) {
        html += '<li><button type="button" class="search__term" data-search-term="' + escapeHtml(term) + '">' + escapeHtml(term) + '</button></li>';
      });
      searchRecentList.innerHTML = html;
      bindTermButtons(searchRecentList);
    }

    /* Clear recent searches */
    if (searchClearRecent) {
      searchClearRecent.addEventListener('click', function () {
        try { localStorage.removeItem('gh_recent'); } catch (e) {}
        if (searchRecent) searchRecent.style.display = 'none';
      });
    }

    /* Save recent on result click */
    if (searchResultsGrid) {
      searchResultsGrid.addEventListener('click', function (e) {
        var link = e.target.closest('.search__product');
        if (link && searchInput.value.trim()) saveRecentSearch(searchInput.value.trim());
      });
    }
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById('mobileDrawer');
  var drawerBackdrop = document.getElementById('drawerBackdrop');
  var burger = document.querySelector('.nav__burger');

  if (drawer && burger) {
    var depth = 0;
    var activeL2 = null;
    var activeL3 = null;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawerBackdrop.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function resetDrawer() {
      drawer.classList.remove('at-l2', 'at-l3');
      if (activeL2) activeL2.classList.remove('is-active');
      if (activeL3) activeL3.classList.remove('is-active');
      activeL2 = null;
      activeL3 = null;
      depth = 0;
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerBackdrop.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(resetDrawer, 450);
    }

    function goTo(id) {
      var panel = document.getElementById(id);
      if (!panel) return;
      if (panel.classList.contains('drawer__level--sub')) {
        if (activeL2) activeL2.classList.remove('is-active');
        activeL2 = panel;
        panel.classList.add('is-active');
        panel.querySelector('.drawer__scroll').scrollTop = 0;
        drawer.classList.add('at-l2');
        drawer.classList.remove('at-l3');
        depth = 1;
      } else if (panel.classList.contains('drawer__level--deep')) {
        if (activeL3) activeL3.classList.remove('is-active');
        activeL3 = panel;
        panel.classList.add('is-active');
        panel.querySelector('.drawer__scroll').scrollTop = 0;
        drawer.classList.add('at-l3');
        depth = 2;
      }
    }

    function goBack() {
      if (depth === 2) {
        drawer.classList.remove('at-l3');
        depth = 1;
        setTimeout(function () {
          if (activeL3) activeL3.classList.remove('is-active');
          activeL3 = null;
        }, 400);
      } else if (depth === 1) {
        drawer.classList.remove('at-l2');
        depth = 0;
        setTimeout(function () {
          if (activeL2) activeL2.classList.remove('is-active');
          activeL2 = null;
        }, 400);
      }
    }

    burger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });

    drawer.querySelectorAll('.drawer__close').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('.drawer__back').forEach(function (btn) {
      btn.addEventListener('click', goBack);
    });

    if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    drawer.querySelectorAll('[data-drawer-go]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(this.dataset.drawerGo);
      });
    });
  }
})();
